import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-container" role="status" aria-live="polite">
      <div className="loading-panel">
        <div className="loading-line" />
        <p className="loading-label">Loading portfolio</p>
      </div>
    </div>
  );
};

export default Loading;
